import React, { useEffect } from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'
import UserProfile from './UserProfile'
import { useSelector } from 'react-redux'
import { HomeFilled } from '@ant-design/icons'
import {
  FaClock,
  FaChild,
  FaBriefcase,
  FaQuestion,
  FaVolumeUp,
  FaFolder,
  FaDoorOpen,
  FaQuestionCircle,
  FaClipboardList,
  FaClipboardCheck,
  FaCheckDouble,
  FaBookReader,
  FaBook,
  FaCheck,
  FaSmileWink,
  FaDesktop,
  FaExclamationTriangle
} from 'react-icons/fa'
import { MdDashboard } from 'react-icons/md'
import { MAIN_MENU } from '../../constants/ServerUrl'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup
const SidebarContent = ({
  sidebarCollapsed,
  setSidebarCollapsed,
  onMenuClick,
}) => {
  let { navStyle, themeType } = useSelector(({ settings }) => settings)
  let { pathname } = useSelector(({ common }) => common)
  let { authUser } = useSelector(({ auth }) => auth)
  let { activeCompany } = useSelector(({ company }) => company)

  // Enabled per company in pemsadmin → System Settings → Incident Log.
  const incidentLogEnabled = Boolean(activeCompany) && Number(activeCompany.incident_log_enabled) === 1


  let selectedKeys = pathname.substr(1)
  let defaultOpenKeys = selectedKeys.split('/')[1]
  // const defaultOpenKeys = selectedKeys.split('/')[1];

  return (
    <>
      <div className='flex items-center justify-center p-2 relative'>
        <UserProfile />
        {/*<AppsNavigation/>*/}
      </div>

      <Menu
        className='bg-blue text-white text-center text-base font-medium mb-5 main-menu'
        mode='inline'
        defaultOpenKeys={[defaultOpenKeys]}
        selectedKeys={[selectedKeys]}
        onClick={onMenuClick}
      >
        {authUser && (
          <MenuItemGroup key='dashboardGroup' className=''>
            {/* <Menu.Item key="home">
                            <div  className="flex mt-5"  onClick={() => {
                                    window.location.href = MAIN_MENU
                            }}>
                                <div className="text-3xl">
                                    <HomeFilled/>
                                </div>
                                <span className="mx-3 md:mx-5">Home</span>
                            </div>
                        </Menu.Item> */}
            <Menu.Item key='dashboard'>
              <Link to='/home' className='flex mt-10'>
                <div className='text-xl md:text-2xl my-auto'>
                  <MdDashboard />
                </div>
                <span className='mx-3 py-1'>Dashboard</span>
              </Link>
            </Menu.Item>
            {authUser.status >= 4 && (
              <Menu.Item key='my-profile'>
                <Link to='/my-profile' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaChild />
                  </div>
                  <span className='mx-4 py-1'>My Profile</span>
                </Link>
              </Menu.Item>
            )}
            {authUser.status >= 4 && (
              <Menu.Item key='announcements'>
                <Link to='/announcements' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaVolumeUp />
                  </div>
                  <span className='mx-4 py-1'>Announcements</span>
                </Link>
              </Menu.Item>
            )}
            {authUser.status >= 4 && (
              <Menu.Item key='attendance'>
                <Link to='/attendance' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaClock />
                  </div>
                  <span className='mx-4 py-1'>Attendance</span>
                </Link>
              </Menu.Item>
            )}

            {authUser.status >= 4 && (
              <Menu.Item key='documents'>
                <Link to='/documents' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaFolder />
                  </div>
                  <span className='mx-4 py-1'>Documents</span>
                </Link>
              </Menu.Item>
            )}

            {/* {authUser.status >= 4 && (
                            <Menu.Item key="enquiries">
                                <Link to="/enquiries" className="flex mt-10">
                                    <div className="text-xl md:text-2xl mt-3">
                                        <FaQuestion/>
                                    </div>
                                    <span className="mx-4 md:mx-5 py-1">Enquiries</span>
                                </Link>
                            </Menu.Item>)} */}

            {authUser.status >= 4 && (
              <Menu.Item key='events'>
                <Link to='/events' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaClipboardList />
                  </div>
                  <span className='mx-4 py-1'>Survey</span>
                </Link>
              </Menu.Item>
            )}

            {authUser.status >= 4 && (
              <Menu.Item key='EmployeeValidation'>
                <Link to='/employeevalidation' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaClipboardCheck />
                  </div>
                  <span className='mx-4 py-1'>Employee Validation</span>
                </Link>
              </Menu.Item>
            )}

            {/* {authUser.status >= 4 && (
              <Menu.Item key='appraisals'>
                <Link to='/appraisals' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaCheckDouble />
                  </div>
                  <span className='mx-4 py-1'>Appraisals</span>
                </Link>
              </Menu.Item>
            )} */}

            {authUser.status >= 4 && (
              <Menu.Item key='exits'>
                <Link to='/exits' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaDoorOpen />
                  </div>
                  <span className='mx-4 py-1'>Exit</span>
                </Link>
              </Menu.Item>
            )}
            {authUser.status >= 4 && (
              <Menu.Item key='leave-tracker'>
                <Link to='/leave-tracker' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaBriefcase />
                  </div>
                  <span className='mx-4 py-1'>Leave</span>
                </Link>
              </Menu.Item>
            )}

            {authUser.status >= 4 && (
              <Menu.Item key='paystubs'>
                <Link to='/paystubs' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaCheck />
                  </div>
                  <span className='mx-4 py-1'>Paystubs</span>
                </Link>
              </Menu.Item>
            )}
            {authUser.status >= 4 && (
              <Menu.Item key='query'>
                <Link to='/query' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaQuestionCircle />
                  </div>
                  <span className='mx-4 py-1'>Query</span>
                </Link>
              </Menu.Item>
            )}

            {authUser.status >= 4 && (
              <Menu.Item key='training'>
                <Link to='/training' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaBookReader />
                  </div>
                  <span className='mx-4 py-1'>Training</span>
                </Link>
              </Menu.Item>
            )}
            {authUser.status >= 4 && (
              <Menu.Item key='performance'>
                <Link to='/performance' className='flex mt-10'>
                  <div className='text-xl md:text-2xl mt-3'>
                    <FaBookReader />
                  </div>
                  <span className='mx-4 py-1'>Performance</span>
                </Link>
              </Menu.Item>
            )}

            {authUser.status >= 4 && incidentLogEnabled && (
                <Menu.Item key='incident-log'>
                    <Link to='/incident-log' className='flex mt-10'>
                        <div className='text-xl md:text-2xl mt-3'>
                            <FaExclamationTriangle />
                        </div>
                        <span className='mx-4 py-1'>Incident Log</span>
                    </Link>
                </Menu.Item>
            )}


            <Menu.Item key='guide'>
              <a
                download
                href='/User Guide - Self Service.pdf'
                className='hidden'
              >
                <div className='text-xl md:text-2xl mt-3'>
                  <FaBook />
                </div>
                <span className='mx-4 py-1'>Guide</span>
              </a>
            </Menu.Item>
          </MenuItemGroup>
        )}
      </Menu>
    </>
  )
}

SidebarContent.propTypes = {}
export default SidebarContent
